import api from './api';

const independentCommissionsService = {
    // Get all commissions for the authenticated independent agent
    getAll: async () => {
        const response = await api.get('/independent/commissions');
        return response.data;
    },

    // Get commission statistics
    getStats: async () => {
        const response = await api.get('/independent/commissions/stats');
        return response.data;
    },

    // Get single commission by ID
    getById: async (id) => {
        const response = await api.get(`/independent/commissions/${id}`);
        return response.data;
    },

    // Create new commission
    create: async (commissionData) => {
        const response = await api.post('/independent/commissions', commissionData);
        return response.data;
    },

    // Update commission
    update: async (id, commissionData) => {
        const response = await api.put(`/independent/commissions/${id}`, commissionData);
        return response.data;
    },

    // Delete commission
    delete: async (id) => {
        const response = await api.delete(`/independent/commissions/${id}`);
        return response.data;
    }
};

export default independentCommissionsService;
